export default __webpack_public_path__ + "static/media/Firesoul Helm.e86e1ff2.jpg";